<template>
  <w-settings-content-template>
    <div slot="content">
    <el-row class="mr-b25" :gutter="20">
        <el-row class="title-bar" type="flex" justify="space-between">
          <el-row class="vertical-center-box">
            <el-col align="left">
              <div class="title-h3 mr-r15">탐색 내역</div>
            </el-col>
          </el-row>
          <el-row class="vertical-center-box">
            <w-header-search-button @click="showSearchHeader"/>
          </el-row>
        </el-row>
        <el-row v-loading="loading">
          <el-table-wrapper :column-default="columnDefault" :total="total" @condition-change="setTableParameter" remote :data="tableData" :columns="columns" :pagination="true"
            :show-custom-header="true" :show-search-tool="searchFlag" ref="machinePatternTable" header-align="center" highlight-current-row>
            <template slot="searchStatus-slot" slot-scope="scope">
              <span v-if="(scope.row.searchStatus) === 'S' || (scope.row.searchStatus) === 'F'">{{searchStatus.SUCCESS}}</span>
              <span v-else-if="(scope.row.searchStatus) === 'E'">{{searchStatus.ERROR}}</span>
              <span v-else>{{searchStatus.CONTINUE}}</span>
            </template>
            <template slot="count-slot" slot-scope="scope">
              <span v-if="scope.row.searchStatus === 'S'" class="link"  @click="showHistPopup(scope.row.histId)">
                {{scope.row.count}}
              </span>
              <span v-else>
                {{EMPTY_TEXT}}
              </span>
            </template>
          </el-table-wrapper>
        </el-row>
        <w-log-ml-hist-pattern-popup ref="patternHistPopup" :histId="histId"></w-log-ml-hist-pattern-popup>
    </el-row>
  </div>
</w-settings-content-template>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { isEmpty, isNil } from 'lodash';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import PatternSearchAPI from '@/api/settings/log/lms-pattern-search-setting';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { searchStatus } from '../constant/patternDefine';
import WLogMlHistPatternPopup from '../popup/LogMlHistPatternPopup';

export default {
  name: 'WMlPatternHist',
  components: {
    WSettingsContentTemplate,
    WLogMlHistPatternPopup,
  },
  data() {
    return {
      histId: null,
      EMPTY_TEXT,
      total: 0,
      start: 0,
      limit: 50,
      loading: false,
      searchFlag: false,
      columnDefault,
      tableData: [],
      searchParams: [],
      searchStatus,
      columns: [
        {
          label: '수행 시간',
          prop: 'startDatetime',
          width: '150px',
          formatter: this.getDateFormatter,
        },
        {
          label: '수행 상태',
          prop: 'searchStatus',
          scopedSlot: 'searchStatus-slot',
          width: '150px',
          formatter: this.getStringFormatter,
        },
        {
          label: '메시지',
          searchable: true,
          prop: 'message',
          formatter: this.getStringFormatter,
        },
        {
          label: '탐색 패턴 수',
          prop: 'count',
          scopedSlot: 'count-slot',
          width: '150px',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    changeCondition(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    getStringFormatter(row, column, value) {
      if (!isNil(value) && !isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    loadData() {
      this.loading = true;
      const params = {
        start: this.start,
        limit: this.limit,
        searchParams: this.searchParams,
      };
      PatternSearchAPI.getMlPatternHist(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '패턴 탐색 내역', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    showHistPopup(histId) {
      this.histId = histId;
      this.$nextTick(() => {
        this.$refs.patternHistPopup.open();
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Pattern/components/MlPatternHist.vue